import initDataRepository from '@/repositories/init-data-repository'
import HistoryRepository from '@/repositories/history-repository'
import AlertHistoryRepository from '@/repositories/alert-history-repository'
import RainRuiHistoryRepository from '@/repositories/rain-rui-history-repository'
import SummaryRepository from '@/repositories/summary-repository'
import PresentRepository from '@/repositories/present-repository'
import WeatherWarningHistoryRepository from '@/repositories/weather-warning-history-repository'
import WeatherWarning2Repository from '@/repositories/weather-warning2-repository'
import WeatherWarningHistory2Repository from '@/repositories/weather-warning-history2-repository'
import NewsRepository from '@/repositories/news-repository'

export default {
  initData: new initDataRepository(),
  history: new HistoryRepository(),
  alertHistory: new AlertHistoryRepository(),
  rainRuiHistory: new RainRuiHistoryRepository(),
  summary: new SummaryRepository(),
  present: new PresentRepository(),
  weatherWarningHistory: new WeatherWarningHistoryRepository(),
  weatherWarning2: new WeatherWarning2Repository(),
  weatherWarningHistory2: new WeatherWarningHistory2Repository(),
  news: new NewsRepository(),
}
